import { mdiAlertOctagon, mdiAlertOutline, mdiCheckCircleOutline, mdiInformationOutline, mdiLoading, } from "@mdi/js";
import React, { useCallback } from "react";
import { Icon } from "../../../../ui/components/icon/Icon";
import { joinClasses } from "../../../../ui/utils/joinClasses";
import { NotificationActions } from "./NotificationActions";
import { NotificationContent } from "./NotificationContent";
import { NotificationControls } from "./NotificationControls";
import { addWordBreakOpportunities, createNotificationHandler, } from "./notificationUtils";
import { useNotificationTranslation } from "./useNotificationTranslation";
const STATUS_MAP = {
    error: { className: "text-danger-strong", icon: mdiAlertOctagon },
    warning: { className: "text-warning-strong", icon: mdiAlertOutline },
    success: { className: "text-success-strong", icon: mdiCheckCircleOutline },
    info: { className: "text-info-strong", icon: mdiInformationOutline },
    activity: { className: "text-info-strong animate-spin", icon: mdiLoading },
    global: { className: "text-info-strong", icon: mdiInformationOutline },
    silent: { className: "text-info-strong", icon: mdiInformationOutline },
};
const getNotificationStatus = (type) => {
    return STATUS_MAP[type];
};
export const NotificationItem = ({ notification, collapsed, onDismiss, onSuppress, onTriggerAction, onExpand, }) => {
    const { actions, id, noDismiss, type, allowSuppress } = notification;
    // Handle translation
    const { translatedTitle, translatedMessage } = useNotificationTranslation({
        notification,
        collapsed,
    });
    const status = getNotificationStatus(type);
    // Event handlers
    const handleDismiss = useCallback(createNotificationHandler(id, onDismiss), [
        id,
        onDismiss,
    ]);
    const handleSuppress = useCallback(createNotificationHandler(id, onSuppress), [id, onSuppress]);
    const handleExpand = useCallback(() => {
        if (notification.group && onExpand) {
            onExpand(notification.group);
        }
    }, [notification.group, onExpand]);
    const handleActionClick = useCallback((actionTitle) => createNotificationHandler(id, (notifId) => onTriggerAction(notifId, actionTitle)), [id, onTriggerAction]);
    if (translatedMessage === undefined && translatedTitle === undefined) {
        return null;
    }
    const lines = addWordBreakOpportunities(translatedMessage || "");
    return (React.createElement("div", { className: "flex gap-x-3 rounded-xs bg-surface-low p-2" },
        React.createElement(Icon, { className: joinClasses(["relative mt-0.5 shrink-0", status.className]), path: status.icon, size: "sm" }),
        React.createElement("div", { className: "relative flex grow flex-col gap-y-2" },
            React.createElement(NotificationContent, { lines: lines, title: translatedTitle }),
            type === "activity" && notification.progress !== undefined && (React.createElement("div", { className: "h-1 w-full overflow-hidden rounded-full bg-surface-high" },
                React.createElement("div", { className: "h-full rounded-full bg-info-strong transition-[width] duration-300", style: { width: `${notification.progress}%` } }))),
            React.createElement(NotificationActions, { actions: actions, collapsed: collapsed, onActionClick: handleActionClick, onExpand: handleExpand })),
        React.createElement(NotificationControls, { allowSuppress: allowSuppress, collapsed: collapsed, noDismiss: noDismiss, onDismiss: handleDismiss, onSuppress: handleSuppress })));
};
